import { useCallback, useEffect, useState } from "react";
import { LoaderCircle } from "lucide-react";
import { usePageMeta } from "../lib/usePageMeta";
import { InvestorAccessGate } from "../components/investor/InvestorAccessGate";
import { InvestorShell } from "../components/investor/InvestorShell";
import { checkInvestorSession, fetchInvestorData } from "../components/investor/investorApi";
import "../components/investor/investor.css";
import "../components/investor/investor-cinematic.css";

export default function InvestorPitchPage() {
  usePageMeta("HUMN — Private Investor Experience", "Controlled-access investor material for HUMN, The Intention Network.");
  const [state, setState] = useState("checking");
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  const loadPitch = useCallback(async () => {
    setState("checking"); setError("");
    try {
      await checkInvestorSession();
      const protectedData = await fetchInvestorData();
      setData(protectedData); setState("authenticated");
    } catch (requestError) {
      setData(null); setState("unauthenticated");
      if (!requestError.message.toLowerCase().includes("access required")) setError(requestError.message);
    }
  }, []);

  useEffect(() => { loadPitch(); }, [loadPitch]);
  useEffect(() => {
    document.documentElement.classList.add("invest-route-active");
    document.documentElement.classList.toggle("invest-authenticated", state === "authenticated");
    if (state === "authenticated") window.__lenis?.stop();
    return () => { window.__lenis?.start(); document.documentElement.classList.remove("invest-route-active", "invest-authenticated", "invest-presenting"); };
  }, [state]);

  if (state === "checking") return <main className="invest-loading" data-testid="invest-loading"><LoaderCircle className="animate-spin"/><span>SECURING INVESTOR SESSION</span></main>;
  if (state !== "authenticated" || !data) return <><InvestorAccessGate onAuthenticated={loadPitch}/>{error&&<div className="invest-global-error" role="alert" data-testid="invest-global-error">{error}</div>}</>;
  return <InvestorShell data={data} onLogout={() => { setData(null); setState("unauthenticated"); }}/>
}